export const READING_PANE_CONTAINER_ID = 'ReadingPaneContainerId';

// Defines the height to consider that the RP has enough space for
// reading.
export const READING_PANE_MIN_VISIBLE_HEIGHT = 500;

export const PRINT_PORTAL_ID = 'print-portal-div';
